import React from "react";

import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

type Props = { className?: string };

export const Italic = (props: SvgIconProps & Props) => {
    return (
        <SvgIcon {...props}>
            <path d="M12.5152 7H13.9848L11.4697 17.5H10L12.5152 7Z" />
        </SvgIcon>
    );
};
